const stringToNumberOrZero = v => (v === '' || v === null || v === undefined ? 0 : Number(v));

export default stringToNumberOrZero;
